type ActionChameleonAnchorProps = {
    actionTypes?: string[];
};
// This is a marker so we can conditionally display surveys/tours in Chameleon based on the action types in a deployment process
// Currently only checks for Kubernetes and Argo CD action types
// See screenshot https://github.com/OctopusDeploy/OctopusDeploy/pull/32573#discussion_r2053078781
export function ActionChameleonAnchor({ actionTypes = [] }: ActionChameleonAnchorProps) {
    const kubernetesActionTypes = [
        "Octopus.KubernetesRunScript",
        "Octopus.KubernetesDeployService",
        "Octopus.KubernetesDeployIngress",
        "Octopus.KubernetesDeployConfigMap",
        "Octopus.KubernetesDeployContainers",
        "Octopus.KubernetesDeploySecret",
        "Octopus.Kubernetes.Kustomize",
        "Octopus.HelmChartUpgrade",
        "Octopus.KubernetesDeployRawYaml",
    ];
    const argoCDActionTypes = ["Octopus.ArgoCD.ImageUpdate", "Octopus.ArgoCD.TemplateUpdate", "Octopus.ArgoCDUpdateImageTags", "Octopus.ArgoCDUpdateManifests"];
    const hasArgoCDActions = actionTypes.some((actionType) => argoCDActionTypes.includes(actionType));
    if (hasArgoCDActions) {
        return <div data-chameleon-id="contains argocd action"></div>;
    }
    const hasKubernetesAction = actionTypes.some((actionType) => kubernetesActionTypes.includes(actionType));
    if (hasKubernetesAction) {
        return <div data-chameleon-tour="contains kubernetes action"></div>;
    }
    return null;
}
